<template>
  <div v-bind:class="wrapperClass">
    <div class="col-lg-3 col-xl-3 tree-wrapper tree-wrapper-column-left" v-if="leftTree">
      <a v-on:click="_openTree($event)" href="#" class="categorie-treeview-trigger">Kategorie<span
        class="icon wb-plus plus-minus"></span></a>
      <div class="categorie-treeview" style="display: none;">
        <tree v-if="treeNodes.length" :treeNodes="treeNodes" @changeNode="_changeNodeListener"/>
      </div>
    </div>
    <div v-bind:class="[contentWrapperClass, 'tree-wrapper-column-right']" style="width: 100%">
      <div class="products-list" v-if="def">
        <h1 v-if="showH1OnOwnRow" class="page-title">{{ t(def.dictionaryKeyCode) }}</h1>
        <div v-if="showHeader" :class="['products-list-options ' + view, rows.length ? '' : 'empty-data']">
          <h1 v-if="showH1" class="page-title">{{ t(def.dictionaryKeyCode) }}</h1>
          <form class="px-5 px-lg-0 order-2" v-on:keyup="_disableSubmit($event)" v-on:keypress="_disableSubmit($event)">
            <div :class="['search-group', def.editor.length ? '' : 'padding-left-0']">
              <search-input
                ref="search"
                v-on:changeQuery="_searchChangeListener"
              />
              <button @click="_refreshListener" type="button" class="btn btn-primary">
                <i class="icon wb-reload" aria-hidden="true"></i>
              </button>
            </div>
          </form>
          <div class="btn-group order-3 grid-view-buttons">
            <span class="count-alert">{{ rowCount }}</span>
            <a v-if="zobrazitTlacitko"
               @click="_viewChangeListener('', $event)"
               href="#"
               v-bind:class="'btn btn-white btn-table-view ' + (view === '' || view === null ? 'active' : '')"
            >
              <span class="icon wb-menu"></span>
            </a>
            <a
               @click="_viewChangeListener('grid-view', $event)"
               href="#"
               v-bind:class="'btn btn-white btn-grid-view ' + (view === 'grid-view' ? 'active' : '')"
            >
              <span class="icon wb-grid-4"></span>
            </a>


          </div>
          <new-button
            v-if="def.editor.length && def.isReadOnly === 'disable'"
            :def="def"
            :parentData="parent"
            :formDataCheckFunction="formDataCheckFunction"
            :urlParentDataProp="urlParentData"
            :dataChanged="dataChanged"
            :readOnly="!showAddButton"
          />
        </div>

        <grid-renderer
          v-if="interpretation !== 'Gallery'"
          @formButtonClicked="formButtonClicked"
          @rowClick="rowClick"
          :def="def"
          :rows="rows"
          :parentData="parent"
          :urlParentDataProp="urlParentData"
          :backRedirect="backRedirect"
          :view="view"
          :animation="animation"
          :updateDataRequest="updateDataRequestComputed"
          :formDataChanged="formDataChanged"
          :rowClickEmit="rowClickEmit"
        />

        <div v-if="showPreloader" class="preloader-wrapper">
          <div class="loader loader-grill"></div>
        </div>

      </div>
      <div v-if="!rows.length" class="empty-data-wrapper">
        <div class="empty-data-content">
          {{ t('tbl_data_no_found') }}
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import DefinitionGetter from './../../model/resource/getter/definitions-getter'
import TableRenderer    from './../../components/grids/renderers/TableRenderer'
import GalleryRenderer  from './../../components/grids/renderers/GalleryRenderer'
import GridRenderer     from './../../components/grids/renderers/grid-renderer'
import SearchInput      from './../../components/grids/search-input'
import NewButton        from './../../components/grids/new-button'
import DataGetter       from './../../model/resource/getter/data-getter'
import Tree             from './renderers/tree/tree'
import { appDefaults }  from './../../defaults'
import SessionStorage   from './../../model/storage/session-storage'
import ConditionHelper  from './../../model/helper/condition-helper'
import Definition       from '../../model/entity/Definition'
import doubleScroll     from '@activix/double-scroll'

export default {
  components: {
    TableRenderer,
    GalleryRenderer,
    GridRenderer,
    SearchInput,
    NewButton,
    Tree
  },
  props:      {
    propDef:               {
      type:    Definition,
      default: function () {
        return null
      }
    },
    page:                  {
      type:    String,
      default: function () {
        return null
      }
    },
    idStructure:           {
      type:    String | Number,
      default: function () {
        return null
      }
    },
    backRedirect:          {
      type:    String,
      default: function () {
        return undefined
      }
    },
    parent:                {
      type:    Object,
      default: function () {
        return null
      }
    },
    urlParentData:         {
      type:    String,
      default: function () {
        return null
      }
    },
    showHeader:            {
      type:    Boolean,
      default: true
    },
    formDataCheckFunction: {
      type:    Function,
      default: null
    },
    updateDataRequest:     {
      type:    Function,
      default: null
    },
    formDataChanged:       {
      type:    Function,
      default: null
    },
    showH1:                {
      type:    Boolean,
      default: true
    },
    showH1OnOwnRow:        {
      type:    Boolean,
      default: false
    },
    propId:                {
      type:    Number,
      default: null
    },
    showAddButton:         {
      type:    Boolean,
      default: true
    },
    dataChanged:           {
      type:    Boolean,
      default: false
    },
    rowClickEmit:          {
      type:    Boolean,
      default: false
    },
  },
  data () {
    return {
      def:            undefined,
      interpretation: undefined,
      endPageScroll:  false,
      offset:         1,
      query:          null,
      rows:           [],
      rowCount:       null,
      view:           SessionStorage.getItem('grid-view', null),
      showPreloader:  false,
      pageChanged:    false,

      wrapperClass:        'panel-body grid row',
      contentWrapperClass: '',
      leftTree:            false,
      treeNodes:           [],
      treeDef:             undefined,
      treeNodeId:          undefined,
      animation:           false
    }
  },

computed: {



zobrazitTlacitko() {
  const aktualniCesta = this.$route.path;

  // Regulární výraz pro cesty, kde NECHCEME, aby se tlačítko zobrazilo
  const regexProZakazaneCesty = /^\/[^/]+\/?$|^\/[^/]+\/scheduler\/ew_Scheduler_01_Dis\/?$/;

  // Zkontroluje, zda cesta NENÍ jednou z těch zakázaných
 return !regexProZakazaneCesty.test(aktualniCesta);
},


    updateDataRequestComputed: function () {
      if (this.updateDataRequest) {
        return this.updateDataRequest
      }

      return (successCallback, originalData) => {
        this._initData()
      }
    },
    computedEventId(){
     return this.$store.getters.getEventId
    }
  },

  created () {
    this._initBase()
    this._initView()

    window.addEventListener('scroll', this._handleScroll)
  },

mounted () {

   // ✅ ZMĚNA: Pokud jsme na Dashboardu, nastavíme 'grid-view'
    if (this.$route.name === 'Dashboard') {
      this.view = 'grid-view' // <-- PŘIDAT TENTO ŘÁDEK
      this.$nextTick(() => {
      setTimeout(() => {
        this._refreshListener()
         }, 300)
     })
  }



  // pokud view není nastavený, inicializuj doubleScroll
  if (this.view === '' || this.view === null) {
    setTimeout(() => {
      $('.table-responsive').doubleScroll()
    }, 500)
  }



},

  destroyed () {
    window.removeEventListener('scroll', this._handleScroll)
  },

  watch: {
    page:        function () {
      this.def         = undefined
      this.treeNodes   = []
      this.query       = null
      this.pageChanged = true
      this._initBase()
    },
    idStructure: function () {
      if (!this.pageChanged) {
        this._initBase()
      }
    },
    view:        function (value) {
      SessionStorage.setItem('grid-view', value)

      setTimeout(() => {
        if (value === '' || value === null) {
          $('.table-responsive').doubleScroll()
        }
        else {
          $('.table-responsive').doubleScroll('remove')
          $('.table-responsive').doubleScroll('destroy')
        }
      }, 10)
    },
    animation:   function (value) {
      if (value) {
        setTimeout(() => {
          this.animation = false
        }, 800)
      }
    },


  // ✅ OPRAVA: Sleduj změny route a znovu načti data
  '$route.name'(newVal, oldVal) {
    if (newVal === 'Dashboard') {
      console.log('🔄 Dashboard aktivní, načítám data...')
      this.$nextTick(() => {
        this.offset = 1
        this.query = null
        this.rows = []
        this.showPreloader = true

        if (this.$refs.search && typeof this.$refs.search.clear === 'function') {
          this.$refs.search.clear()
        }

        this._initData() // ← KLÍČOVÉ: načti data
      })
    }
  },

  },

  methods: {

    _openTree (event) {
      event.preventDefault()
      $('.categorie-treeview').slideToggle(200).toggleClass('opened')
      $(event.target).toggleClass('opened')
      $('.categorie-treeview-trigger > .icon').toggleClass('wb-plus').toggleClass('wb-minus')
    },

    _initBase () {
      this._initDef()
          .then(() => {
            this.offset = 1
            this._initData()
          })
    },

    /**
     * @private
     */
    _initDef (pageArg, idStructureArg, changeInterpretation = true) {
      let page        = pageArg ? pageArg : this.page,
          idStructure = idStructureArg ? idStructureArg : this.idStructure
      let success = (def) => {
            this.def = def
            if (changeInterpretation) {
              this.interpretation = def.response.data[0].Interpretation
            }

            this._setViewByInterpretation()

            this.$emit('defLoaded', def)
          },
          error   = (error) => {
            this.handleApiError(error)
          },
          args    = {
            code:                   page,
            idtEntityStructureFrom: idStructure
          }

      return DefinitionGetter.getDataDefinition(args, success, error)
    },

    /**
     *
     * @param appendRows
     * @param defArg
     * @param interpretationArg
     * @param idArg
     * @private
     */
    _initData (appendRows = false, defArg, interpretationArg, idArg) {
      let interpretation = interpretationArg ? interpretationArg : this.interpretation,
          def            = defArg ? defArg : this.def

      let success = (data) => {
        // omezeni pro vykreslovani stromu - v pripade, ze se na strance vykresluje strom je prvni zaznam z dat
        // GetPaget definice stromu !! -> data se nepouzivaji pro vykreslovani
        if (ConditionHelper.isInterpretationTree(interpretation) && !defArg) {
          this._initializeTreeStepsForRender(data)

          return
        }

        if (appendRows) {
          data.data.forEach((item) => {
            this.rows.push(item)
          })

          this.showPreloader = false

          return
        }

        this.rows          = data.data
        this.rowCount      = data.rowCount
        this.showPreloader = false
        this.pageChanged   = false

        this.$emit('dataLoaded')
      }

      let id = idArg ? idArg : this.$route.params.id || this.computedEventId
      // parent = this.$route.params.parent ? JSON.parse(this.$route.params.parent) : null

      // if (parent && parent.id) {
      //   id = parent.id
      // }

      if (!id && this.parent && this.parent.hasOwnProperty('id')) {
        id = this.parent.id
      }

      if (!id) {
        id = this.propId
      }

      let dataGetter    = new DataGetter()
      dataGetter.def    = def
      dataGetter.id     = id
      dataGetter.offset = this.offset
      dataGetter.query  = this.query
      dataGetter.user   = this.$store.getters.user

      return dataGetter.get(success, (error) => {this.handleApiError(error)})
    },

    _initView () {
      if (this.view === null && window.innerWidth <= 800) {
        this.view = 'grid-view'

        return
      }

      if (this.view !== null) {
        return
      }

      this.view = null
    },

    _setViewByInterpretation () {
      switch (this.interpretation) {
        case 'tree':
          this.wrapperClass        = 'panel-body grid row'
          this.contentWrapperClass = 'col-lg-9 col-xl-9'
          this.leftTree            = true
          break
        default:
          this.wrapperClass        = 'panel-body grid row'
          this.contentWrapperClass = ''
          this.leftTree            = false
          break
      }
    },

    /**
     *
     * @private
     */
    _initializeTreeStepsForRender (data) {
      if (!data.data.length) {
        return
      }

      this.treeNodes            = [data.data[0]]
      this.treeNodes[0].SUBTREE = JSON.parse(this.treeNodes[0].TITEM_SUBTREE)
      this.treeDef              = this.def.list[0]
      this.treeNodeId           = this.treeNodes[0].ID

      this._initDef(this.treeDef.Code, this.treeDef.idtEntityStructureFrom, false)
          .then(() => {
            this._initData(false, this.def, null, this.treeNodeId)
          })
    },

    /**
     *
     * @private
     */
    _handleScroll () {
      this.topPosition = $(document).scrollTop()

      let y      = window.pageYOffset,
          result = $(document).height() - $(window).height()

      if (result >= y + 80 && this.endPageScroll) {
        this.endPageScroll = false

        return
      }

      if (result <= y + 80 && !this.endPageScroll) {
        this.endPageScroll = true
        if (this.rowCount > appDefaults.api.limit && this.rowCount > this.rows.length) {
          this.offset++
          this.showPreloader = true
          this._initData(true, this.def, null, this.treeNodeId)
        }
      }
    },

    /**
     *
     * @param query
     * @private
     */
    _searchChangeListener (query) {
      if (!ConditionHelper.isInterpretationTree(this.def.interpretation)
        || (ConditionHelper.isInterpretationTree(this.def.interpretation) && this.treeNodes.length > 0)
      ) {
        this.query = query
      }
      this.offset        = 1
      this.showPreloader = true
      this.rows          = []

      this._initData(false, this.def, null, this.treeNodeId)
    },

    /**
     *
     * @private
     */

_refreshListener () {
  this.offset = 1
  this.query = null
  this.rows = []
  this.showPreloader = true

  if (this.$refs.search && typeof this.$refs.search.clear === 'function') {
    this.$refs.search.clear()
  }

  this._initData() // ← PŘIDAT!
  console.log('🔄 Refresh spuštěn')
},

    /**
     *
     * @param e
     * @returns {boolean}
     * @private
     */
    _disableSubmit (e) {
      let keyCode = e.keyCode || e.which
      if (keyCode === 13) {
        e.preventDefault()
        return false
      }
    },

    /**
     *
     * @param treeNode
     * @private
     */
    _changeNodeListener (treeNode) {
      this.treeNodeId = treeNode.ID
      this._initData(false, this.def, null, this.treeNodeId)
    },

    /**
     *
     * @param view
     * @param event
     * @private
     */
    _viewChangeListener (view, event) {
      event.preventDefault()
      this.view      = view
      this.animation = true
    },

    formButtonClicked () {
      this.$emit('formButtonClicked')
    },

    rowClick (rowData) {
      this.$emit('rowClick', rowData)
    }
  }
}
</script>

<style>
@font-face {
  font-family: Roboto;
  /*src: url(../fonts/Roboto-Regular.ttf);*/
  font-weight: 400
}

@font-face {
  font-family: Roboto;
  /*src: url(../fonts/Roboto-Bold.ttf);*/
  font-weight: 700
}

@media (min-width: 992px) {
  .container {
    max-width: 992px
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1440px
  }
}

.form-element .panel-group {
  margin-bottom: 0;
}

.row .form-element:last-child .panel-group {
  margin-bottom: 10px;
}

h3 {
  font-weight: 400;
  margin-bottom: 0
}

.breadcrumb {
  padding-left: 0
}

.grid-view-buttons {
  margin-right: 5px;
}

.empty-data-wrapper {
  background: #FFF;
  padding: 30px 15px;
  border-radius: 5px;
}

.empty-data-content {
  height: 50px;
  font-weight: 400;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab-content .empty-data-wrapper {
  padding: 0;
}

.categorie-treeview {
  background-color: #fff;
  box-shadow: 0 1px 0 #e6e9ea;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  -moz-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box
}

.search-group {
  display: flex;
  align-items: center;
  position: relative;
  padding: 15px;
  justify-content: flex-end;
}

.search-group::before {
  font-family: "Font Awesome";
  content: "\f002";
  font-weight: 400;
  position: relative;
  left: 22px
}

.search-group .icon.wb-reload {
  font-size: 15px;
  -webkit-transform: scaleX(-1);
  -moz-transform: scaleX(-1);
  transform: scaleX(-1)
}

.search-group .form-control {
  height: 36px;
  width: calc(100% - 45px);
  padding-left: 30px
}

.search-group .form-control:focus {
  border-color: #4598cb
}

.search-group button {
  height: 36px;
  width: 36px;
  min-width: 36px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px
}

@media (min-width: 992px) {
  .search-group::before {
    left: 25px
  }
}

@media (max-width: 992px) {
  .search-group .form-control {
    width: 100%;
  }
}

.btn-primary {
  background-color: #4598cb;
  border-color: #4598cb
}

.btn-primary:hover {
  background-color: #428bca
}

.categorie-treeview {
  display: none;
  padding-top: 10px;
  padding-bottom: 10px;
}

.categorie-treeview.opened {
  -webkit-border-radius: 0 0 5px 5px;
  -moz-border-radius: 0 0 5px 5px;
  border-radius: 0 0 5px 5px;
  -moz-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box
}

.categorie-treeview .items-count {
  background: #f1f4f5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
  -moz-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  margin-left: 5px;
  width: 20px;
  height: 20px;
  color: #37474f;
  font-size: 10px;
  line-height: 19.05px;
  letter-spacing: .3px
}

.categorie-treeview .list-group-item {
  border-radius: 0 !important;
  padding: 10px 15px;
  color: #37474f;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: .42px
}

.categorie-treeview .list-group-item a {
  display: block;
  padding-top: 7px;
}

.categorie-treeview .list-group-item.node-selected .subcategorie {
  color: #fff
}

.categorie-treeview .list-group-item .icon {
  position: absolute;
  right: 16px;
  font-size: 16px;
  margin-right: 0;
}

.tree-wrapper .icon.plus-minus {
  background: #f1f4f5;
  border-radius: .215rem;
  width: 36px;
  height: 36px;
  line-height: 35px;
  text-align: center;
}

/*.categorie-treeview .list-group-item .icon.expand-icon {*/
/*  width: calc(100% - 15px)*/
/*}*/

/*.categorie-treeview .list-group-item:hover {*/
/*  background-color: #4598cb !important;*/
/*  color: #fff !important*/
/*}*/

/*.categorie-treeview .list-group-item:hover .subcategorie {*/
/*  color: #fff*/
/*}*/

.categorie-treeview .subcategorie {
  color: #939ea4;
  font-size: 12px;
  line-height: 19.05px;
  letter-spacing: .48px
}

@media (min-width: 992px) {
  .categorie-treeview {
    display: block !important;
  }
}

.tree-wrapper {
  margin-bottom: 15px;
}

.tree-wrapper .search-group::before {
  left: 25px;
}

.panel-body .tree-wrapper-column-left {
  padding-left: 0px;
}

.panel-body .tree-wrapper-column-right {
  padding-right: 0px;
}

.categorie-treeview-trigger {
  display: flex;
  background-color: #fff;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  color: #939ea4;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.05px;
  letter-spacing: .42px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  -moz-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  box-shadow: 0 1px 0 #e6e9ea
}

.categorie-treeview-trigger.opened {
  box-shadow: none;
  -webkit-border-radius: 5px 5px 0 0;
  -moz-border-radius: 5px 5px 0 0;
  border-radius: 5px 5px 0 0;
  -moz-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box
}

.categorie-treeview-trigger .icon {
  color: #000;
  font-size: 16px;
}

.categorie-treeview-trigger:hover {
  text-decoration: none;
  /*color: #4598cb*/
}

@media (min-width: 992px) {
  .categorie-treeview-trigger {
    display: none
  }
}

.form-row {
  margin-left: 0px;
  margin-right: 0px;
}

.products-list {
  margin-top: 0;
  width: 100%;
}

.tab-content .grid.row {
  margin: 0;
}

.tab-content .master-slave .grid.row {
  margin-left: 10px;
  margin-right: 10px;
}

.tab-content .master-slave h4 {
  margin: 1rem 0 0.5rem 0;
}

.products-list-options {
  position: -webkit-sticky;
  position: sticky;
  /*top: 47px;*/
  z-index: 99;
  display: flex;
  align-items: center;
  padding: 15px 0;
  -webkit-border-radius: 5px 5px 0 0;
  -moz-border-radius: 5px 5px 0 0;
  border-radius: 5px 5px 0 0;
  -moz-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  background-color: #fff;
}

.products-list-options h1 {
  width: 60%;
}

.tab-content .products-list-options {
  padding: 15px 0;
}

.tab-content .master-slave .products-list-options {
  padding: 15px 10px;
}

.products-list-options.grid-view {
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  -moz-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
}

.products-list-options.empty-data {
  margin-bottom: 15px;
  border-radius: 5px;
}

.tab-content .master-slave .products-list-options.empty-data {
  margin-bottom: 10px;
}

.tab-content .products-list-options {
  border-radius: 0;
}

.tab-content .master-slave .products-list-options.grid-view {
  margin-bottom: 10px;
}

.products-list-options.grid-view::before,
.products-list-options.empty-data::before {
  display: none
}

.tab-content .products-list-options.grid-view {
  box-shadow: none;
  -webkit-box-shadow: none;
}

.products-list-options .search-group {
  padding: 0;
}

.products-list-options .search-group.padding-left-0 {
  padding-left: 0;
}

.products-list-options form {
  width: 100%;
  padding-right: 5px !important;
}

.products-list-options .btn {
  width: 36px;
  height: 36px;
  min-width: 36px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center
}

.products-list-options .count-alert {
  position: absolute;
  z-index: 5;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  transform: translateX(-50%);
  top: -10px
}

.products-list-options .btn-secondary {
  margin-right: auto
}

@media (min-width: 992px) {
  .products-list-options {
    flex-wrap: nowrap
  }

  /*.products-list-options::before {*/
  /*  width: calc(100% - 63px)*/
  /*}*/
  /*.products-list-options .search-group {*/
  /*  padding: 15px*/
  /*}*/
  .tab-pane .products-list-options .search-group {
    padding-left: 0;
    left: -10px;
    width: calc(100% + 10px);
  }

  .grid-view-buttons {
    margin-right: 14px;
  }
}

.count-alert {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #dc3545;
  min-width: 18px;
  min-height: 18px;
  padding: 0 5px;
  color: #fff;
  font-size: 10px;
  font-weight: 400;
  line-height: 19.05px;
  letter-spacing: .3px;
  -webkit-border-radius: .215rem;
  -moz-border-radius: .215rem;
  border-radius: .215rem;
  -moz-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box
}

.btn-secondary {
  background: #11c26d;
  border-color: #11c26d
}

.btn-secondary:active, .btn-secondary:focus {
  box-shadow: none !important;
  outline: 0 !important
}

.btn-secondary:hover {
  border-color: #18a15f;
  background-color: #18a15f
}

.btn-white {
  border: 1px solid #d5dadb
}

.btn-white.active, .btn-white:hover {
  background-color: #e8eced;
  box-shadow: none !important;
  outline: 0 !important
}

.btn-white .icon {
  color: #939ea4
}

.content .btn .icon {
  font-size: 15px
}

.products-wrapper {
  position: relative;
  padding: 10px 0px 15px;
  box-shadow: 0 1px 0 #e6e9ea;
  background-color: #fff;
  -webkit-border-radius: 0 0 5px 5px;
  -moz-border-radius: 0 0 5px 5px;
  border-radius: 0 0 5px 5px;
  -moz-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box
}

.tab-content .products-wrapper {
  padding: 0;
}

.products-wrapper.grid-view {
  padding: 0;
  background-color: transparent;
  box-shadow: none
}

@media (max-width: 1255px) {
  .products-wrapper:not(.grid-view) .shadow {
    pointer-events: none;
    width: 100%;
    height: calc(100% - 15px);
    z-index: 15;
    position: absolute;
    top: 0
  }

  .products-wrapper:not(.grid-view) .shadow.shadow-left {
    display: none;
    left: 15px;
    -webkit-box-shadow: inset 36px 0 22px -25px rgba(0, 0, 0, .15);
    -moz-box-shadow: inset 36px 0 22px -25px rgba(0, 0, 0, .15);
    box-shadow: inset 36px 0 22px -25px rgba(0, 0, 0, .15)
  }

  .products-wrapper:not(.grid-view) .shadow.shadow-right {
    right: 15px;
    -webkit-box-shadow: inset -36px 0 22px -25px rgba(0, 0, 0, .15);
    -moz-box-shadow: inset -36px 0 22px -25px rgba(0, 0, 0, .15);
    box-shadow: inset -36px 0 22px -25px rgba(0, 0, 0, .15)
  }
}

@media (min-width: 576px) {
  .products-wrapper:not(.grid-view) .shadow.shadow-left {
    left: 13px
  }

  .products-wrapper:not(.grid-view) .shadow.shadow-right {
    right: 13px
  }
}

@media (min-width: 992px) {
  .products-wrapper:not(.grid-view) .shadow {
    height: calc(100% - 30px)
  }

  .products-wrapper:not(.grid-view) .shadow.shadow-left {
    left: 30px
  }

  .products-wrapper:not(.grid-view) .shadow.shadow-right {
    right: 30px
  }
}

@media (min-width: 992px) {
  .products-wrapper {
    padding: 0px;
    padding-top: 10px;
  }
}

.table {
  min-width: 700px
}

.products {
  display: table;
  border-radius: 3px;
  /*border: 1px solid #d5dadb;*/
  border-top: none;
  min-width: 980px;
  width: 100%;
  overflow: hidden
}

.products.grid-view {
  display: block;
  background-color: transparent;
  min-width: 100%;
  border: none
}

.products .products-heading {
  display: table-header-group
}

.products .products-view {
  display: table-row-group
}

.products .products-view .product-columns {
  display: table-row
}

.products .products-view .product-columns .badge {
  display: inline;
}

.products .products-view.grid-view .product-columns .badge {
  display: inline-block;
  padding: 5px 7px;
}

.products .products-view.grid-view .product-columns .badge.badge-lg {
  margin-bottom: 3px;
  display: block;
  padding: 0.30em .6em;
}

.products .products-view .product-columns:first-of-type .column-name {
  /*border-top: none*/
}

.products .products-view .product-columns:nth-of-type(2) .column-name {
  /*border-top: 3px solid #4598cb*/
}

.products .products-view .product-columns:hover,
.products .products-view.grid-view .product-columns:hover {
  background-color: #e6e8e88f;
}

.products .products-view .product-columns.product-header-row:hover {
  background-color: #FFF;
}

.products .products-view .product-columns.last-row,
.products .products-view.grid-view .product-columns.last-row {
  /*background: #11c26d;*/
  /*color: #FFF;*/
  /*background: #e8eced;*/
}

.products .products-view .product-columns.success-row,
.products .products-view.grid-view .product-columns.success-row {
  background: #bdfddf;
  color: #FFF;
}

.products .products-view .column-name {
  display: table-cell;
  vertical-align: middle;
  border-top: 1px solid #e6e8e88f;
  /*border-right: 1px solid #d5dadb;*/
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: .56px;
  padding: 8px 15px;
  color: #76838f;
}

/*.products .products-view .column-name.first {*/
/*  font-weight: 600;*/
/*  color: #76838f;*/
/*}*/

.products .products-view .column-name:last-of-type {
  border-right: none
}

.products .products-view .column-name.header-column {
  color: #646f79 !important;
  text-transform: none !important;
  font-weight: 700;
  border-bottom: 1px solid #dcdcdc;
  background: #dcdcdc;
}

.products .column-name.header-column.number-format {
  text-align: right;
}

.products .products-view:not(.grid-view) .column-name .number-format {
  display: block;
  text-align: right;
}

.products .products-view .column-name.preview img {
  max-width: 70px;
  max-height: 70px;
  height: 70px;
  width: 70px;
  object-fit: scale-down
}

.products .products-view .column-name.state {
  text-align: center
}

.products .products-view .column-name.state span {
  display: inline-block
}

.products .products-view .column-name.add-to-cart {
  text-align: center;
  min-width: 150px;
  width: 400px;
}

.products .products-view .column-name.add-to-cart .amount {
  width: 150px;
  margin: 0 auto 10px auto;
}

.products .products-view .column-name.add-to-cart .amount input {
  text-align: center
}

.products .products-view .column-name.add-to-cart .amount .input-group-btn button {
  font-size: 0;
  max-width: 36px;
  background-color: #f2f6f7;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center
}

.products .products-view .column-name.add-to-cart .amount .input-group-btn button::before {
  font-family: 'Font Awesome';
  font-size: 16px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 5px;
  z-index: 10;
  color: #505050
}

.products .products-view .column-name.add-to-cart .amount .input-group-btn button:hover {
  background-color: #4598cb;
  border-color: #4598cb;
  color: #fff
}

.products .products-view .column-name.add-to-cart .amount .input-group-btn button:hover::before {
  color: #fff
}

.products .products-view .column-name.add-to-cart .amount .input-group-btn button.bootstrap-touchspin-down::before {
  content: '\f0d7'
}

.products .products-view .column-name.add-to-cart .amount .input-group-btn button.bootstrap-touchspin-up::before {
  content: '\f0d8'
}

.products .products-view .column-name.add-to-cart .btn {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 15px;
  padding-right: 15px;
  width: 100px
}

.products .products-view .column-name.add-to-cart .btn.add {
  display: block;
  width: auto;
  margin-bottom: 5px
}

.products .products-view .column-name.title {
  color: #37474f
}

.products .products-view .column-name.price {
  min-width: 100px;
  color: #11c26d;
  font-weight: 700;
  text-transform: uppercase;
  text-align: right
}

.products .products-view .column-name.desc {
  color: #939ea4
}

.products .products-view.grid-view {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -.25rem;
  flex-direction: row; /* výchozí stav */
}




.products .products-view.grid-view .product-columns {
  display: flex;
  background-color: #fff;
  border: 1px solid #d5dadb;
  margin: 0 .25rem;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  -moz-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  flex-direction: column;
  align-items: center;
  flex-basis: 100%;
  /* padding-top: 15px; */
  padding-bottom: 10px;
  margin-bottom: 1rem;
  overflow: hidden;
}

.card-header{
  width:100%
}
.products .products-view.grid-view .product-columns:first-of-type {
  display: none
}

.products .products-view.grid-view .product-columns .column-name {
  display: flex;
  border-right: none;
  border-top: none;
  text-align: left;
  justify-content: left;
  width: 100% !important;
  margin-bottom: .5rem;
  padding: 2px 15px;
  line-height: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.products .products-view.grid-view .product-columns .column-name img {
  height: 80px;
  width: 80px;
  object-fit: scale-down
}

.products .products-view.grid-view .product-columns .column-name.state {
  flex-direction: column;
  justify-content: center;
  align-items: center
}

.products .products-view.grid-view .product-columns .column-name.add-to-cart {
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  max-width: 100% !important;
}

.products .products-view.grid-view .product-columns .column-name.add-to-cart .amount {
  max-width: 150px;
  margin: 0 auto 10px;
}

.products .products-view.grid-view .product-columns .column-name.add-to-cart .btn-secondary {
  min-width: 100px;
  justify-content: center;
}

.products .products-view.grid-view .product-columns .enu-button {
  padding: 0 3px;
}

.products .products-view.grid-view .product-columns .column-name span.content-grid-unit {
  padding: 0 3px;
  flex: 100%;
}






.products .products-view.grid-view .product-columns {
  flex-basis: 100%;
}

@media (max-width: 449px) {
  .products .products-view.grid-view .product-columns {
    flex-basis: 100%;
  }
}







  /* styl, který se má použít */

   .side-panel .product-columns {
    flex-basis: 100%!important;
  }

/* 🔹 Výjimka pro Dashboard – vždy 100% na všech rozlišeních */
.side-panel .products .products-view.grid-view .product-columns {
  flex-basis: 100% !important;
}

/* Nebo pokud máte jinou třídu pro Dashboard container */
[data-page="dashboard"] .products .products-view.grid-view .product-columns {
  flex-basis: 100% !important;
}


@media (min-width: 550px) {
  .products .products-view.grid-view .product-columns {
    flex-basis: calc(50% - .5rem);
  }
}

@media (min-width: 1200px) {
  .products .products-view.grid-view .product-columns {
    flex-basis: calc(25% - .5rem);
  }
}


.state-label {
  display: block;
  color: #fff;
  font-size: 9px;
  font-weight: 500;
  line-height: 20px;
  padding-left: 5px;
  padding-right: 5px;
  text-transform: uppercase;
  letter-spacing: .9px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  -moz-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box
}

.state-label.label-blue {
  background-color: #17a2b8
}

.state-label.label-green {
  background-color: #11c26d
}

/*.products .products-view:not(.grid-view) .product-columns .column-name.add-to-cart .btn-secondary,*/
/*.products .products-view:not(.grid-view) .product-columns .column-name.add-to-cart .amount {*/
/*  float: left;*/
/*}*/

.products .products-view:not(.grid-view) .product-columns .column-name.add-to-cart .btn-secondary {
  margin: 0 10px 3px;
  width: auto;
}

.master-slave .panel-body.grid.row {
  padding: 0 0 15px 0;
}

@media (max-width: 992px) {
  .categorie-treeview {
    margin-top: -5px;
  }

  .categorie-treeview .search-group {
    padding-top: 0;
  }

  .panel-body .tree-wrapper-column-left,
  .panel-body .tree-wrapper-column-right {
    padding-left: 0px;
    padding-right: 0px;
  }

  @media (max-width: 479px) {
    .page-title {
      display: none;
    }

    .search-group {
      width: calc(100% + 15px);
      margin-left: -15px;
    }
  }
}




</style>
